<template>
    <v-card>
        <Toolbar
            :toolbarTitle="$t('Gruppenforen Antworten')"
            :tooltipMessage="$t('Auf dieser Seite haben Sie Überblick auf Thema Rückmeldungen')"
            :showDrawer="false"
            :lastPath="{ name: 'groupForumThreads' }"
        />
        <v-container>
            <AnswerList />
        </v-container>
    </v-card>
</template>

<script>
import ForumMixin from '../../Components/GroupForum/Mixins/GroupForumMixin';
import Toolbar from '../../Components/Generic/Toolbar';
import DeleteAnswer from '../../Components/Forum/DeleteAnswer';
import AnswerList from '../../Components/GroupForum/AnswerList';

export default {
    name: 'group-forum-answers',
    mixins: [ForumMixin],
    components: {
        Toolbar,
        AnswerList
    },
    data: () => ({
        editorPermissions: {
            add: false,
            update: false,
            delete: false,
            move: false,
            copy: false,
            details: false,
            groups: false
        }
    }),
    mounted() {
        const permissions = {
            add: [this.getSelectedThread.canAnswer],
            update: [this.getSelectedThread.canAnswer],
            delete: [this.getSelectedThread.canAnswer],
            move: false,
            copy: false,
            details: false,
            groups: false
        };
        this.validateEditorState(permissions).then((result) => {
            this.editorPermissions = result;
        });
    }
};
</script>
